import { useCashFundPartnerPlacement } from '@shared/hooks/useCashFundPartnerPlacement/useCashFundPartnerPlacement';
import { getTransferPartnerConfig } from './transferPartnerConfigs';
import type { TransferPartnerConfig } from './transferPartnerConfigs';

export type ActiveTransferPartners = Readonly<{
  activeTransferConfig: TransferPartnerConfig | null;
  activeRepeatConfig: TransferPartnerConfig | null;
}>;

export const useActiveTransferPartners = (): ActiveTransferPartners => {
  const { partner: transferPartner } = useCashFundPartnerPlacement('transferToBank');
  const { partner: repeatTransferPartner } = useCashFundPartnerPlacement('transferToBankRepeat');

  return {
    activeTransferConfig: transferPartner ? getTransferPartnerConfig(transferPartner) : null,
    activeRepeatConfig: repeatTransferPartner ? getTransferPartnerConfig(repeatTransferPartner) : null,
  };
};
